// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { GET_CLAIM, INTIMATE_CLAIM, DOWNLOAD_CLAIM_DOC, UPLOAD_CLAIM_DOC } from '../../../../../common/constant'
import { get, post } from '../../../../../common/api'
import Api from '../../../../../common/api/multipart'

export const actionGetClaim = createAsyncThunk('claimStore/actionGetClaim', async (params, thunkAPI) => {
    return await post(GET_CLAIM, params, thunkAPI)
})
export const actionIntimateClaim = createAsyncThunk('claimStore/actionIntimateClaim', async (params, thunkAPI) => {
    return await post(INTIMATE_CLAIM, params, thunkAPI)
})

export const actionDownloadClaimDoc = createAsyncThunk('dashboardStore/actionDownloadClaimDoc', async (params, thunkAPI) => {
    return await post(DOWNLOAD_CLAIM_DOC, params, thunkAPI)
})

export const actionUploadClaimDoc = createAsyncThunk('dashboardStore/actionUploadClaimDoc', async (params, thunkAPI) => {
    return await Api.multipart(UPLOAD_CLAIM_DOC, params, thunkAPI)

})

export const claimSlice = createSlice({
    name: 'claimStore',

    initialState: {
        //get policy
        loadingGetClaim: false,
        getClaim: null,

        //claim intimate
        loadingClaimIntimate: false,
        intimateClaim: null,

        //downloadclaim
        loadingDowanloadClaimDoc: false,
        downloadClaim: null,

        //uploadclaimDoc
        loadingUploadClaimDoc: false,
        uploadClaimDoc: null
    },
    reducers: {
        //reset or delete public store data
        resetGetClaimResponse: (state) => {
            state.getClaim = null
        },
        resetIntimateClaimResponse: (state) => {
            state.intimateClaim = null
        },

        resetClaimDocDowanloadResponse: (state) => {
            state.downloadClaim = null
        },
        resetUploadClaimResponse: (state) => {
            state.uploadClaimDoc = null
        }
    },
    extraReducers: builder => {
        builder
            .addCase(actionGetClaim.pending, (state) => {
                state.loadingGetClaim = false
            })
            .addCase(actionGetClaim.fulfilled, (state, action) => {
                state.loadingGetClaim = true
                state.getClaim = action.payload
            })
            .addCase(actionGetClaim.rejected, (state) => {
                state.loadingGetClaim = false
            })

            // claim intimate
            .addCase(actionIntimateClaim.pending, (state) => {
                state.loadingClaimIntimate = true
            })
            .addCase(actionIntimateClaim.fulfilled, (state, action) => {
                state.loadingGetClaim = true
                state.intimateClaim = action.payload
            })
            .addCase(actionIntimateClaim.rejected, (state) => {
                state.loadingClaimIntimate = false
            })


            // claim download
            .addCase(actionDownloadClaimDoc.pending, (state) => {
                state.loadingDowanloadClaimDoc = true
            })
            .addCase(actionDownloadClaimDoc.fulfilled, (state, action) => {
                state.loadingDowanloadClaimDoc = true
                state.downloadClaim = action.payload
            })
            .addCase(actionDownloadClaimDoc.rejected, (state) => {
                state.loadingDowanloadClaimDoc = false
            })


            // upload claim document
            .addCase(actionUploadClaimDoc.pending, (state) => {
                state.loadingUploadClaimDoc = true
            })
            .addCase(actionUploadClaimDoc.fulfilled, (state, action) => {
                state.loadingUploadClaimDoc = true
                state.uploadClaimDoc = action.payload
            })
            .addCase(actionUploadClaimDoc.rejected, (state) => {
                state.loadingUploadClaimDoc = false
            })
    }
})
export const { resetGetClaimResponse, resetIntimateClaimResponse, resetClaimDocDowanloadResponse, resetUploadClaimResponse } = claimSlice.actions

export default claimSlice.reducer